import React from 'react';
import { PlaylistProvider } from '../../components/PlaylistContext';
import { withOrganization } from '../../components/Session';
import FindAudio from './FindAudio';

const FindAudioWithPlaylistFilter = (props) => (
  <PlaylistProvider>
    <FindAudio {...props} />
  </PlaylistProvider>
  );

export default withOrganization(FindAudioWithPlaylistFilter); 